app.component("hostPreparation", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/hostPreparation/hostPreparation.html",
	controller: "hostPreparationController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("hostPreparationController", [
	"$scope",
	function ($scope) {
		  $scope.strippingDiameterOptions = [
				{ value: "SIZE_7_0", name: "7.0" },
				{ value: "SIZE_7_5", name: "7.5" },
				{ value: "SIZE_8_0", name: "8.0" },
				{ value: "SIZE_8_5", name: "8.5" },
				{ value: "SIZE_9_0", name: "9.0" },
				{ value: "SIZE_9_5", name: "9.5" },
				{ value: "SIZE_10_0", name: "10.0" },
				{ value: "OTHER", name: "Other (specify)" },
			];

            $scope.strippingMethodOptions = [
				{ value: "REVERSE_SINSKEY_HOOK", name: "Reverse Sinskey Hook" },
				{ value: "ENDOTHELIAL_SCRAPER", name: "Endothelial Scraper" },
				{ value: "OTHER", name: "Other (specify)" },
			];
	},
]);